import { BaseSerializer } from '/src/app/core/serializers/baseSerializer';

class LeaderboardSerializer extends BaseSerializer {
  deserialize(raw) {
    const serverRes = raw.data || raw.error;
    const success = serverRes.statusCode == 200 || serverRes.statusCode == 404;
    if (!success) {
      return {
        statusCode: serverRes.statusCode || raw.status || 500,
        success: false,
        message: serverRes.message || 'Impossible de charger le classement. Veuillez réessayer.',
        // ancien message: (serverRes.message || 'Erreur lors de la récupération') + ` Code d'erreur: ADS_ERR_${serverRes.statusCode || raw.status || '1000'}`
        data: null
      };
    }
    return {
      statuCode: 200,
      success: true,
      message: 'Ads got',
      data: (Array.isArray(serverRes?.data?.appInfo?.ads)
        ? serverRes?.data?.appInfo?.ads
        : []
      ).map((ad) => {
        return {
          id: ad.id,
          title: ad.title,
          description: ad.description,
          pictureUrl: ad.pictureUrl,
          isSmall: ad.isSmall
        };
      })
    };
  }

  serialize() {}
}

export const serializer = new LeaderboardSerializer();
